import { observable, computed, action } from "mobx";
import {comm} from '../../comm'
import { integration } from "../../integration";
import {max} from 'lodash';
import { Xp } from "./Xp";
import { Account } from "./Account";
import { FacebookAccount } from "./FacebookAccount";
import { GuestAccount } from "./GuestAccount";

export class User {

	constructor(parent) {
		this.parent = parent;
	}

	xpData = new Xp();

	@observable platform = 'ruby7';
	@observable id = 0;
	@observable name = 'unset';
	@observable image = 'img/user/default.png';
	// @observable language = 'en';
	@observable currency = 'usd';
	@observable anonName = '';
	@computed get isAnonymous(){
		return this.anonName && this.anonName.length > 0;
	};
	@observable balance = null;
	@observable lastBetAmount = 10000;
	@computed get hasSeenOrSkippedTutorial(){
		return this.hasSeenTutorial || localStorage.getItem('skippedTutorial') === 'yes';
	}
	//for one hand game:
	@observable hasSeenTutorial = true;
	// @observable hasSeenTutorial = false;
	@observable hasSeenFreeRollMessage = false;
	@observable matchCount = 0;
	@observable _hearts = 0;
	@observable animateToHearts = 0;

	// @observable level = 0;
	@computed get level(){
		return this.xpData.currentLevel;
	}

	// @observable xp = 0;
	@computed get xp(){
		return this.xpData.currentXp;
	}

	// @observable xpStart = 0;
	@computed get xpStart(){
		return this.xpData.currentXpStart;
	}

	// @observable xpNext = 1;
	@computed get xpNext(){
		return this.xpData.currentXpNext;
	}

	// @observable animateToLevel = 0;
	@computed get animateToLevel(){
		return this.xpData._target.level;
	}

	// @observable animateToXp = 0;
	@computed get animateToXp(){
		return this.xpData._target.xp;
	}

	@computed get xpPercentage(){
		//console.log('delay', 'xp', this.xpStart, this.xp, this.xpNext);
		return (this.xp - this.xpStart) / this.xpNext;
	}

	@computed get animateToXpPercentage(){
		return (this.animateToXp - this.xpStart) / this.xpNext;
	}

	@observable localClaimTime = 0;

	@computed get canClaimTimedReward(){
		return this.localClaimTime < Date.now();
	}

	achievementColorMods = {
		"tutorial": 2
	}

	@computed get trophies(){
		var bronze = 0;
		var silver = 0;
		var gold = 0;
		this.achievements.forEach(a => {
			var mod = this.achievementColorMods[a.Current.Type] || 0;
			for(let i = 0; i < a.Current.Quantity; i++){
				switch (i + mod) {
					case 0:
						bronze++;
						break;
					case 1:
						silver++;
						break;
					default:
						gold++;
						break;
				}
			}
		})
		return [
			bronze,
			silver,
			gold
		];
	}

	@action.bound updateAchievements(immediate){
		return comm.GetAchievements()
		.then(data => {
			var replacements = [];
			data.Payload.Achievements.forEach(a => {
				if(a.IsLevel){
					this.xpData.updateFromServer(a, immediate)
				} else {
					replacements.push(a);
				}
			});
			this.achievements = replacements;
		})
		.then(integration.processNotifications)
	}

	@observable achievements = [];

	set hearts(val){
		this._hearts = val;
		this.animateToHearts = val;
	}

	@computed get hearts(){
		return this._hearts;
	}

	@computed get heartsGained(){
		return this.animateToHearts - this._hearts;
	}

	@action.bound heartAnimComplete(){
		console.log('update heart amount visual')
		this._hearts = this.animateToHearts;
	}

	@action.bound updateHearts(immediate){
		return comm.GetBalance()
		.then((response) => {
			this.animateToHearts = response.Payload.FreeRolls;
			if(immediate){
				this._hearts = this.animateToHearts;
			}
			return response;
		});
	}

	// LevelUpReward: {ConfirmationKey: "2284a984ec593b37e61ce60d51c8a9b569a2920598832802e7e50eb0c6f55e17", Level: 2,…}
	// ConfirmationKey: "2284a984ec593b37e61ce60d51c8a9b569a2920598832802e7e50eb0c6f55e17"
	// Level: 2
	// Rewards: {roll: 4}
	// roll: 4

	@action.bound updateXp(immediate){

		return comm.GetXpLevel().then(data => {
			//console.log(data);
			this.xpData.updateFromServer(data, immediate)
			window.store.debug = `
				level ${this.level} |
				animateToLevel ${this.animateToLevel} |
				xpStart ${this.xpStart} |
				xp ${this.xp} |
				animateToXp ${this.animateToXp} |
				xpNext ${this.xpNext} |
				xpIsCurrent ${this.xpIsCurrent} | instant ${immediate}
			`;
			return data;
		});
	}

	@action.bound levelUpComplete(){
		this.xpData.currentLevel++;
	}

	@action.bound xpAnimComplete(){
		this.xpData.setComplete();
	}

	@computed get xpIsCurrent(){
		return this.xp === this.animateToXp;
	}

	@action.bound setXpIsUpdated(){
		this.xpData.setComplete();
	}

	@computed get levelIsCurrent(){
		return this.animateToLevel === this.level;
	}

	apple = new Account(this,'apple','ap');
	facebook = new FacebookAccount(this,'facebook','fb');
	guest = new GuestAccount(this,'guest','anon');

	login(confirm){
		this.isReady = false;
		//This is also the priority order in case multiple accounts have the same level
		const accounts = [
			this.guest,
			this.facebook,
			this.apple,
		];

		//Check for old data
		this.updateOldData()

		var siuId = this.guest.localData.id;
		var tosId = localStorage.getItem('acceptedTosId');
		this.whenReady = Promise.all(
			accounts.map(a => a.login(siuId, tosId))
		)
		.catch(result => {
			throw new Error(result);
		})
		.then(() => {
			const connectedAccounts = accounts.filter(a => a.isConnected);
			//console.log("Account Manager", connectedAccounts.length+' Connected Accounts Found', connectedAccounts)
			var xp = connectedAccounts.map(a => a.serverData.Xp);
			const highestXp = max(xp);
			if(highestXp > 0){
				setPersistentStorage('hasSeenHumanIntro', 'true');
				setPersistentStorage('hasSeenBotIntro', 'true');
				setPersistentStorage('skippedTutorial', 'yes');
			}
			var masterAccount = connectedAccounts.find(a => a.serverData.Xp === highestXp);
			comm.SetCommToken(masterAccount.serverData.Token);
			var accountChanges = [];
			//ensure that all other accounts are
			connectedAccounts.forEach(a => {
				if(a.serverData.AnonymousUsername !== masterAccount.serverData.AnonymousUsername){
					//console.log("Account Manager", "Changing Account", a, masterAccount.serverData.AnonymousUsername)
					accountChanges.push(
						a.changeSIUAccount(masterAccount.serverData.AnonymousUsername)
					);
				}
			})
			//console.log("Account Manager", accountChanges.length+" Accounts Changed")
			return window.logins = Promise.all(accountChanges);
		})
		.then(() => {
			var profileAndNotificationPromise = [];
			if(this.parent.fcmId){
				// this.parent.fcmNeedsUpdate = false;
				profileAndNotificationPromise.push(comm.RegisterFCM(this.parent.fcmId));
			}
			//TODO: remove this logic from being here and instead call individual user profile naming functions in priority order.
			if(this.facebook.isConnected){
				profileAndNotificationPromise.push(this.facebook.getProfileData().then((result) => {
					if(result && (
						this.guest.serverData.Profile.Name !== result[0] ||
						this.guest.serverData.Profile.ImageUrl !== result[1]
					)){
						this.guest.serverData.Profile.Name = result[0];
						this.guest.serverData.Profile.ImageUrl = result[1];
						// window.store.debugArray.push(`258 updating server profile ${result[0]} ${result[1]}`)
						return comm.SetProfile('fb',result[0], result[1]);
					} else {
						// window.store.debugArray.push(`260 got fb name ${result[0]} but no change`)
					}
				})
				.catch((err) => {
					console.error(err);
				}))
			} else {
				//guest account naming will be used.
				this.guest.serverData.Profile.Name = 'Player_'+this.guest.serverData.UserId;
				this.guest.serverData.Profile.ImageUrl = "";
				profileAndNotificationPromise.push(comm.SetProfile('su',this.guest.serverData.Profile.Name,this.guest.serverData.Profile.ImageUrl));
			}
			return Promise.all(profileAndNotificationPromise);
		})
		.then((result) => {
			this.isReady = true;
			integration.setAnalyticsUserId(this.guest.localData.id);
			return this.updateFromNetwork(this.guest.serverData)
			.then(() => {
				const connectedAccounts = accounts.filter(a => a.isConnected);
				connectedAccounts.forEach(a => {
					a.isLoggedIn = true;
				})
				if(confirm){
					this.loginConfirmed = true;
				}
				window.setPersistentStorage('login-time', Date.now());
				return result;
			});
		});
		return this.whenReady;
	}

	updateOldData(){
		//V1 => V2
		var fbUserId = localStorage.getItem('fbUserId');
		var siuId = localStorage.getItem('username');
		var appleId = localStorage.getItem('appleId');
		if(fbUserId){
			this.facebook.localData.id = fbUserId;
			this.facebook.localData.token = localStorage.getItem('facebookToken');
			this.facebook.applyToLocalStorage()
		}
		if(appleId){
			this.apple.localData.id = appleId;
			this.apple.applyToLocalStorage();
		}
		if(siuId){
			this.guest.localData.id = siuId;
			this.guest.applyToLocalStorage();
		}
		localStorage.removeItem('fbUserId');
		localStorage.removeItem('facebookToken');
		localStorage.removeItem('username');
		localStorage.removeItem('appleId');
	}

	@observable isReady = false;

	@observable loginConfirmed = false;

	@computed get mustLogin(){
		if(this.loginConfirmed) return false;

		var showLogin = true;
		if(this.parent.isIOS){
			//show login if apple and facebook is not connected.
			showLogin = !this.apple.isLoggedIn && !this.facebook.isLoggedIn;
		} else {
			//show login if facebook is not connected
			showLogin = !this.facebook.isLoggedIn;
		}

		//if we are good to log in, then
		if(!showLogin){
			setTimeout(() => this.loginConfirmed = true, 500);
		}
		return showLogin;
	}

	// @action.bound confirmGuest(){
	// 	this.loginMethod = 'guest';
	// }

	updateFromNetwork(data){
		var name = data.Profile.Name;
		this.id = data.UserId;
		this.name = name;
		this.anonName = name;
		this.hearts = data.FreeRolls;
		this.hasSeenTutorial = data.HasSeenTutorial;
		this.hasSeenFreeRollMessage = data.HasSeenOutOfRolls;
		this.matchCount = data.MatchCount;
		this.image = data.Profile.ImageUrl;
		this.localClaimTime = Date.now() - (data.ServerTime - data.NextClaimTime) * 1000;
		return Promise.resolve();
	}

}
